export default "__VITE_ASSET__Bn7GdKZc__"